import http from '../../../../libs/http'
export default (id, payload = { name: '' }) => http.put(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/categories/${id}`, payload)
